import React from 'react';
import { Checkbox, InputNumber } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useFormatCurrency, useCurrencySymbol } from '../../../../hooks/useFormatters';

interface CustomAmountInputProps {
  useCustomAmount: boolean;
  customAmount: number | null;
  defaultAmount: number | null;
  onUseCustomAmountChange: (e: CheckboxChangeEvent) => void;
  onCustomAmountChange: (value: number | null) => void;
  disabled?: boolean;
  showDefaultAmount?: boolean;
}

export const CustomAmountInput: React.FC<CustomAmountInputProps> = ({
  useCustomAmount,
  customAmount,
  defaultAmount,
  onUseCustomAmountChange,
  onCustomAmountChange,
  disabled = false,
  showDefaultAmount = false
}) => {
  const formatCurrency = useFormatCurrency();
  const currencySymbol = useCurrencySymbol();
  return (
    <div style={{ marginBottom: '16px' }}>
      <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>Amount: *</div>
      {showDefaultAmount && defaultAmount !== null && (
        <div style={{ marginBottom: '8px', fontSize: '12px', color: '#666' }}>
          Default Amount: {formatCurrency(defaultAmount)}
        </div>
      )}
      <Checkbox 
        checked={useCustomAmount}
        onChange={onUseCustomAmountChange}
        disabled={disabled}
      >
        Use Custom Amount
      </Checkbox>
      {useCustomAmount && (
        <div style={{ marginTop: '8px' }}>
          <InputNumber
            inputMode="decimal"
            value={customAmount}
            onChange={onCustomAmountChange}
            min={0}
            step={0.01}
            precision={2}
            style={{ width: '100%' }}
            placeholder="Enter custom amount"
            disabled={disabled}
            prefix={currencySymbol}
          />
        </div>
      )}
      {!useCustomAmount && defaultAmount !== null && (
        <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#f0f0f0', borderRadius: '4px' }}>
          <strong>Amount:</strong> {formatCurrency(defaultAmount)}
        </div>
      )}
    </div>
  );
};

